import React, {useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import { Outlet } from "react-router-dom";
import Menu from "../Components/Menu/Menu";
import TopBar from "../Components/Menu/TopBar";
import Footer from "../Components/Menu/Footer";

export default function () {

  const menuOpen = useSelector(state => state.menuOpenClose);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <Menu />
        <div className={`wrapper d-flex flex-column flex-row-fluid app-dynamic-part${menuOpen? "": " wider"}`} id="kt_wrapper">
          <TopBar />

          <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
            <div id="kt_content_container" className="container-fluid">

              <Outlet />

              {/*<Footer/>*/}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}